import { type PropsWithChildren } from "react";

type Variant = "default" | "yes" | "no" | "accent" | "warn" | "live";

export function Pill({
  variant = "default",
  children,
  className = "",
}: PropsWithChildren<{ variant?: Variant; className?: string }>) {
  const cls = {
    default: "pill",
    yes: "pill pill-yes",
    no: "pill pill-no",
    accent: "pill pill-accent",
    warn: "pill pill-warn",
    live: "pill pill-no pill-live",
  }[variant];
  return <span className={`${cls} ${className}`}>{children}</span>;
}
